module.exports = __webpack_public_path__ + "static/media/CBNImg9.94836e28.webp";